import type { ArticleBlock } from "@/types/content";

const ArticleBody = ({ blocks }: { blocks: ArticleBlock[] }) => (
  <div className="space-y-6">
    {blocks.map((block, index) => {
      if (block.type === "h2") {
        return (
          <h2
            key={index}
            id={`section-${index}`}
            className="scroll-mt-28 pt-2 font-heading text-xl font-black text-foreground-950 md:text-2xl"
          >
            {block.text}
          </h2>
        );
      }
      if (block.type === "quote") {
        return (
          <blockquote
            key={index}
            className="border-l-4 border-accent-500 bg-accent-100/60 px-5 py-4 font-heading text-base leading-relaxed text-foreground-800 md:text-lg"
          >
            {block.text}
          </blockquote>
        );
      }
      if (block.type === "list") {
        return (
          <ul key={index} className="space-y-3">
            {block.items?.map((item) => (
              <li key={item} className="flex gap-3 text-sm leading-relaxed text-foreground-700 md:text-base">
                <i className="ri-checkbox-circle-fill mt-0.5 text-base text-secondary-600"></i>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        );
      }
      return (
        <p key={index} className="text-sm leading-[1.9] text-foreground-700 md:text-base md:leading-[2]">
          {block.text}
        </p>
      );
    })}
  </div>
);

export default ArticleBody;